module.exports = __webpack_public_path__ + "static/willard_logo-e494c2868e8366b34c5dd74f82bcbdbd.png";